import {
  browserTracingIntegration,
  init,
  replayIntegration,
} from '@sentry/react'

import { getErrorUrl } from 'shared/lib/errorText'

import { SentryDsn, SentryIgnoreApis } from './types'

export const initSentry = () => {
  init({
    dsn: SentryDsn,
    tracesSampleRate: 0.01,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.01,
    tracePropagationTargets: ['api.myservice.com'],
    integrations: [browserTracingIntegration(), replayIntegration()],
    beforeSend(event, hint) {
      const [_, ...errorUrl] =
        getErrorUrl(hint?.originalException)?.split('api/') || ''

      if (SentryIgnoreApis.includes(errorUrl?.join(''))) return null

      return event
    },
  })
}
